<template>
  <div class="playtimes-calendar-wrapper">
    <div class="playtimes-sticky-title schedules-bg-layer" v-html="movie.filmTitle"></div>
    <div
      v-for="(performanceGroup, index) in getCalendarPerformances()"
      :key="index"
      class="playtimes-calendar schedules-bg-layer"
    >
      <template v-if="performanceGroup.performances && performanceGroup.performances.length > 0">
        <!-- Performance Attributes -->
        <div v-if="performanceGroup.hasAttributes" class="performance-attributes-wrapper">
          <div class="performance-attributes" data-js-performance-attributes>
            <ul>
              <li v-if="performanceGroup.isCombinedSite" class="sitename">
                <span>{{ performanceGroup.siteName }}</span>
              </li>
              <li v-for="attribute in performanceGroup.attributeNameSlug" :key="attribute.name">
                <span>
                  <a v-if="attribute.slug" :href="`/mehr/filmreihe/${attribute.slug}`">
                    <span v-html="attribute.name"></span>
                  </a>
                  <span v-else v-html="attribute.name"></span>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="playtimes-calendar__buttons">
          <PlaytimeButton
            v-for="performance in performanceGroup.performances"
            :key="performance.performanceId"
            :performance="performance"
            :show-date="true"
            :movie="movie"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import PlaytimeButton from "./PlaytimeButton.vue";

const props = defineProps({
  performanceGroups: {
    type: Array,
    required: true,
    validator: (value) => Array.isArray(value),
  },
  movie: {
    type: Object,
    default: null,
  },
});

const getCalendarPerformances = () => {
  const groups = props.performanceGroups || [];
  return groups
    .map((group) => ({
      ...group,
      performances: Object.entries(group.performances)
        .map(([performanceId, p]) => ({ ...p, performanceId, ...group }))
        .sort((a, b) => (a.unixdatetime ?? 0) - (b.unixdatetime ?? 0)),
    }))
    .sort(
      (a, b) =>
        Number(b.hasAttributes) - Number(a.hasAttributes) ||
        (a.attributeSort ?? 999) - (b.attributeSort ?? 999),
    );
};
</script>
